import { CheckCircleOutlined, TrendingUpOutlined } from '@mui/icons-material';
import { CardContainer, Tag } from 'finara-components';
import React from 'react';

import type { OrganizationDetail } from '@/types/superAdminClients';

interface ProductosActivosTabProps {
  clientDetail: OrganizationDetail;
}

export const ProductosActivosTab: React.FC<ProductosActivosTabProps> = ({ clientDetail }) => {
  const { products } = clientDetail;

  // Format currency
  const formatCurrency = (value: number) => {
    return `$${value.toLocaleString('es-MX', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  };

  const productsList = [
    {
      id: 'spei',
      name: 'SPEI',
      description: 'Transferencias electrónicas',
      total: products.spei.total,
      icon: <TrendingUpOutlined className="text-muted" />,
    },
    {
      id: 'nomina',
      name: 'Nómina',
      description: 'Pagos de nómina',
      employeeCount: products.nomina.employeeCount,
      icon: <TrendingUpOutlined className="text-muted" />,
    },
    {
      id: 'adelantos',
      name: 'Adelantos',
      description: 'Adelantos de nómina',
      total: products.adelantos.total,
      icon: <TrendingUpOutlined className="text-muted" />,
    },
  ];

  return (
    <CardContainer>
      <h3 className="text-lg font-semibold text-brand-white mb-6">
        Lista de Productos Habilitados
      </h3>

      <div className="space-y-6">
        {productsList.map(product => (
          <div key={product.id} className="border border-border rounded-lg p-6">
            <div className="flex flex-col lg:!flex-row lg:!items-start lg:!justify-between mb-6">
              <div className="mb-4 lg:!mb-0">
                <div className="flex items-center gap-3 mb-2">
                  {product.icon}
                  <h4 className="text-lg font-semibold text-brand-white">{product.name}</h4>
                  <Tag variant="green">Habilitado</Tag>
                </div>
                <p className="text-sm text-muted">{product.description}</p>
              </div>
              <div className="text-left lg:!text-right">
                {'total' in product && (
                  <>
                    <p className="text-3xl font-bold text-brand-white">
                      {formatCurrency(product.total ?? 0)}
                    </p>
                    <p className="text-sm text-muted">Total</p>
                  </>
                )}
                {'employeeCount' in product && (
                  <>
                    <p className="text-3xl font-bold text-brand-white">{product.employeeCount}</p>
                    <p className="text-sm text-muted">Empleados</p>
                  </>
                )}
              </div>
            </div>

            {/* Integration Status */}
            <div className="bg-white/5 rounded-lg p-4">
              <div className="flex items-center gap-2 mb-2">
                <CheckCircleOutlined className="text-green-600" fontSize="small" />
                <span className="text-sm font-medium text-green-600">Conectado</span>
              </div>
              <p className="text-sm text-muted">Estado de integración:</p>
              <p className="text-sm text-brand-white">
                Producto activo y funcionando correctamente
              </p>
            </div>
          </div>
        ))}
      </div>
    </CardContainer>
  );
};
